/**
 * Exports button bar-related design tokens
 */

export const defaultVariant = 'primary';
export const defaultKind = 'fill'; // 'fill' | 'outline' | 'text'
export const defaultSize = 'medium';

export const invalidBorderColor = 'alert/50';
export const invalidBorderStyle = 'solid';